import React from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Spin, Form, Button, InputNumber } from 'antd';

import { Select, Input } from 'antd';
import { actions, asyncUpdate, asyncGet } from './reducers';
import { formItemLayout, formatFormData } from './utils';
const FormItem = Form.Item;

class Edit extends React.Component {
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.modalHide();
        this.props.getTransferData({ selectedRowKeys: [] });
    };
    handleOk = () => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                for (let i in values) {
                    if (!values[i]) {
                        delete values[i];
                    }
                }
                await this.props.asyncUpdate(formatFormData(values));
                this.props.form.resetFields();
                this.props.modalHide();
                this.props.getTransferData({ selectedRowKeys: [] });
            }
        });
    };
    render() {
        const { isModalShow, isLoading, item } = this.props;
        const { getFieldDecorator } = this.props.form;
        const form = (
            <Form>
                <Row>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="设备ID">
                            {getFieldDecorator('clientId', {
                                initialValue: item.clientId,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入设备ID',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} disabled/>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="架子ID">
                            {getFieldDecorator('shelfId', {
                                initialValue: item.shelfId,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入架子ID',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }}/>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="搜索ID">
                            {getFieldDecorator('searchId', {
                                initialValue: item.searchId,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入搜索ID',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }}/>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="客户端类型">
                            {getFieldDecorator('os', {
                                initialValue: item.os,
                                rules: [
                                    {
                                        required: true,
                                        message: '请选择客户端类型',
                                    },
                                ],
                            })(
                                <Select style={{ width: '100%' }} placeholder="请选择">
                                    <Option value="android">android</Option>

                                    <Option value="ios">ios</Option>
                                </Select>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="横坐标">
                            {getFieldDecorator('x', {
                                initialValue: item.x,
                                rules: [
                                    {
                                        required: true,
                                        message: '请填写横坐标',
                                    },
                                ],
                            })(<InputNumber />)}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="纵坐标">
                            {getFieldDecorator('y', {
                                initialValue: item.y,
                                rules: [
                                    {
                                        required: true,
                                        message: '请填写纵坐标',
                                    },
                                ],
                            })(<InputNumber />)}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="目标版本号">
                            {getFieldDecorator('targetVersion', {
                                initialValue: item.targetVersion,
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入目标版本号',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }}/>,
                            )}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );
        return (
            <span>
                <Modal
                    width={800}
                    title="修改"
                    visible={isModalShow}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    confirmLoading={isLoading}
                    maskClosable={false}
                    okText="确定"
                    cancelText="取消">
                    <Spin spinning={isLoading} tip="保存中...">
                        {form}
                    </Spin>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    item: state.clientList.list.reduce((a, b) => (b.clientId === state.clientList.currentSelectId ? b : a), {}),
    isModalShow: state.clientList.uiStatus.isUpdateShow,
    isLoading: state.clientList.uiStatus.isLoading,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(actions.changeUiStatus({ isUpdateShow: false })),
    asyncUpdate: contents => dispatch(asyncUpdate(contents)),
    asyncGet: () => dispatch(asyncGet()),
    getTransferData: data => dispatch(actions.getTransferData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Edit));



// WEBPACK FOOTER //
// ./pages/client/clientList/edit.js